import { Component, ojs, app, state, v } from "modular-openscriptjs";
import { dom, tool } from "../../../fotastart";
import { pageInfo, scrollToTop, setCurrentLocationCoordinates, either, oneOf, formatThousand, randomInt, empty } from "../../../helpers";
import { PAGES } from "../../../declarations";

const h = app("h");
const api = app("api");
const routes = app("routes");
const $e = app("$e");
const gc = app("gc");

export default class BusinessesPage extends Component {
	page = 1;
	filters = state({ nearby: true, all: true, deals: false });
	latitude = null;
	longitude = null;

	render(...args) {
		pageInfo(PAGES.BUSINESSES);
		scrollToTop();
		this.page = 1;
		this.filters.value = { nearby: false, all: true, deals: false };
		this.latitude = null;
		this.longitude = null;

		setCurrentLocationCoordinates(
			false,
			(latitude, longitude) => {
				this.latitude = latitude;
				this.longitude = longitude;

				
				if(this.filters.value.nearby != true) return;
				
				let prevPage = this.page;

				this.page = 1;
				dom.empty(dom.get(`[biz-id='b-profile']`));

				if (prevPage == 1) this.fetchBusinesses(false);
			},
			true
		);

		return h.div(
			{
				class: "py-md-5",
			},
			h.div(
				{ class: "sticky-top", style: "top: 60px;" },
				h.div(
					{
						class: "bg-light d-flex flex-column gap-2 p-3 rounded border",
					},
					h.div(
						{ class: "input-group rounded-3" },

						h.input({
							id: "bp-business-search",
							type: "search",
							class: "form-control fs-4",
							placeholder: "Search...",
							aria_label: "search",
							listeners: {
								keydown: function (event) {
									const key = event.key || event.keyCode;
									if (key === "Enter" || key === 13) {
										h.getComponent("BusinessesPage").search();
									}
								},
							},
						}),

						h.span(
							{
								class: "input-group-text",
								onclick: this.method("search"),
							},
							h.SolidIcon("magnifying-glass", {
								style: "font-size: large;",
							})
						)
					),

					v(this.filters, (filters) => {
						let f = filters.value;

						return h.div(
							{
								class: "d-flex border rounded-3 bg-body-secondary",
							},
							h.span(
								{
									class: "btn rounded-0 flex-fill border-end d-flex align-items-center gap-2 justify-content-center rounded-start-3 fw-bold",
									onclick: this.method("selectFilter", [
										"nearby",
									]),
								},
								either(
									f.nearby == true,
									{ class: "bg-secondary text-white" },
									{ class: "bg-body-secondary text-dark" }
								),
								h.SolidIcon("location-pin"),
								h.span("Near Me")
							),
							h.span(
								{
									class: "btn rounded-0 flex-fill border-end d-flex align-items-center gap-2 justify-content-center fw-bold",
									onclick: this.method("selectFilter", [
										"deals",
									]),
								},
								either(
									f.deals == true,
									{ class: "bg-secondary text-white" },
									{ class: "bg-body-secondary text-dark" }
								),
								h.SolidIcon("tag"),
								h.span("With Deals")
							),
							h.span(
								{
									class: "btn rounded-0 flex-fill border-0 d-flex align-items-center gap-2 justify-content-center rounded-end-3 fw-bold",
									onclick: this.method("selectFilter", [
										"all",
									]),
								},
								either(
									f.all == true,
									{ class: "bg-secondary text-white" },
									{ class: "bg-body-secondary text-dark" }
								),
								h.SolidIcon("globe"),
								h.span("All")
							)
						);
					})
				)
			),
			h.InfiniteScroll({
				child: h.div(
					{
						biz_id: `b-profile`,
						class: "pt-5 row g-2 g-md-3",
					},
					...args
				),
				callback: (entries, observer, marker) => {
					entries.forEach((entry) => {
						if (!entry.isIntersecting) return;
						this.getBusinesses(marker, `b-profile`);
					});
				},
			}),

			h.Fab([
				h.ScanQRFab(),
				h.button(
					{
						class: "btn btn-dark",
						onclick: h.func("fireEvent", $e.app.needs.orderOptions),
					},
					h.i({ class: "fa-solid fa-pen" })
				),
			])
		);
	}

	async getBusinesses(marker, holderId) {
		let spinner = h.Spinner({
			class: "p-3 my-auto mx-auto",
			parent: marker,
			resetParent: true,
		});

		await this.fetchBusinesses();

		spinner.remove();
	}

	search() {
		let prevPage = this.page;

		this.page = 1;
		dom.empty(dom.get(`[biz-id='b-profile']`));

		if (prevPage == 1) this.fetchBusinesses(false);
	}

	async fetchBusinesses(append = true) {
		let page = this.page++;
		let payload = { page };
		let searchInput = dom.id("bp-business-search");
		let filters = tool.deepCopy(this.filters.value);
		let holderId = "b-profile";

		filters.latitude = this.latitude;
		filters.longitude = this.longitude;

		if (!empty(searchInput.value)) {
			payload.query = searchInput.value?.trim();
		}

		payload.filter = JSON.stringify(filters);

		let result = await api.get(`${routes.businesses}`, payload);

		dom.id(`bp-no-business-found`)?.remove();

		if (result) {
			let businesses = result.data.businesses.data;
			let holder = dom.get(`[biz-id='${holderId}']`);

			if (!append) dom.empty(holder);

			for (let business of businesses) {
				h.BusinessesView(business, {
					parent: holder,
					class: "bg-white",
				});
			}

			if (result.data.businesses.data.length == 0) {
				this.page = page;

				if (this.page == 1) {
					h.div(
						{
							parent: dom.get(`[biz-id='${holderId}']`),
							resetParent: true,
							class: "text-secondary fst-italic text-center",
							id: "bp-no-business-found",
						},
						"You're all caught up"
					);
				}
			}
		} else {
			h.div(
				{
					parent: dom.get(`[biz-id='${holderId}']`),
					resetParent: true,
					class: "text-secondary fst-italic text-center",
					id: "bp-no-business-found",
				},
				"You're all caught up"
			);
		}
	}

	selectFilter(key) {
		let filters = tool.deepCopy(this.filters.value);

		if (filters[key] == true) {
			filters[key] = false;
		} else {
			filters[key] = true;
		}

		let hasKey = false;

		for (key in filters) {
			if (filters[key] == true) {
				hasKey = true;
				break;
			}
		}

		if (!hasKey) {
			filters["all"] = true;
		}

		this.filters.value = filters;

		let prevPage = this.page;

		this.page = 1;
		dom.empty(dom.get(`[biz-id='b-profile']`));

		if (prevPage == 1) this.fetchBusinesses(false);
	}
}

class BusinessesView extends Component {
	render(business, ...args) {
		return h.div(
			{
				class: "biz-view-card h-100 d-flex gap-3 rounded-3 border p-3",
				$class: "col-12 col-md-6",
				role: "button",
				onclick: h.func("route.to", "user.view-profile", {
					user:
						business?.id == gc.user?.id ? "current" : business?.id,
				}),
			},
			h.div(
				{
					class: "d-flex justify-content-center align-items-center p-2",
				},
				h.span(
					h.img(
						{
							class: "rounded-circle border",
						},
						either(
							business.profile_photo_path,
							{ src: business.profile_photo_path },
							{
								src: `/assets/images/business_profiles/${randomInt(
									1,
									5
								)}.png`,
							}
						)
					)
				)
			),

			h.div(
				{ class: "flex-fill" },
				h.div(
					{
						class: "d-flex flex-column gap-3 justify-content-between h-100",
					},
					h.div(
						{ class: "d-flex flex-column gap-2" },
						h.div(
							{ class: "d-flex flex-column" },
							h.div({ class: "fs-3" }, business?.display_name),
							h.span(
								{ class: "text-primary" },
								"@",
								business?.username
							)
						),

						h.span(
							{ class: "text-dark fst-italic mt-1" },
							business?.bio
						),

						either(business?.location, () => [
							h.div(
								{
									class: "d-flex gap-2 text-secondary m-0 fs-xsm",
								},
								h.span(
									{
										class: "text-secondary-subtle",
									},
									h.i({
										class: "far fa-map",
									})
								),
								h.span(
									oneOf(
										business?.shop_location
											?.readable_address,
										business?.location
									)
								)
							),
							h.div(
								{
									class: "d-flex gap-2 m-0 text-secondary fs-xsm align-items-center flex-wrap",
								},
								h.span(h.i({ class: "far fa-clock" })),
								either(
									business?.operating_hours?.is_opened,
									() => [
										{ class: "text-success" },
										h.span("Today"),
										h.span("●"),
										h.span(
											business?.operating_hours?.opens_at
										),
										h.span("—"),
										h.span(
											business?.operating_hours?.closes_at
										),
										h.span("●"),
										h.span(
											business?.operating_hours?.message
										),
									],
									() =>
										h.span(
											business?.operating_hours?.message
										)
								)
							),
						])
					),
					h.div(
						{
							class: "d-flex gap-3",
							role: "button",
						},
						h.div(
							{
								class: "d-flex flex-column align-items-center flex-fill gap-1",
								onclick: h.func(
									"route.to",
									"user.view-followers",
									{
										user:
											business?.id == gc.business?.id
												? "current"
												: business?.id,
									}
								),
							},
							h.span(
								{ class: "fs-sm text-info-emphasis" },
								formatThousand(business.follower_count)
							),
							h.span({ class: "fs-xsm" }, "Followers")
						),
						h.div({ class: "vr" }),
						h.div(
							{
								class: "d-flex flex-column align-items-center flex-fill gap-1",
								role: "button",
							},
							h.span(
								{ class: "fs-sm" },
								formatThousand(business.like_count)
							),
							h.span({ class: "fs-xsm" }, "Likes")
						),
						h.div({ class: "vr" }),
						h.div(
							{
								class: "d-flex flex-column align-items-center flex-fill gap-1",
								role: "button",
							},
							h.span(
								{ class: "fs-sm text-success" },
								formatThousand(business.carted_count)
							),
							h.span({ class: "fs-xsm" }, "Carted")
						)
					)
				)
			),
			...args
		);
	}
}

ojs(BusinessesPage, BusinessesView);
